import { createContext, useCallback, useContext, useMemo, useRef, useState } from 'react'
import type { ReactNode } from 'react'

interface Message {
  texte: string
  erreur: boolean
}

interface ValeurToast {
  signaler: (texte: string) => void
  alerter: (texte: string) => void
}

const Contexte = createContext<ValeurToast | null>(null)

export function FournisseurToast({ children }: { children: ReactNode }) {
  const [message, setMessage] = useState<Message | null>(null)
  const minuterie = useRef<number | undefined>(undefined)

  const afficher = useCallback((texte: string, erreur: boolean) => {
    setMessage({ texte, erreur })
    window.clearTimeout(minuterie.current)
    // Une erreur reste plus longtemps : elle demande une action au vendeur.
    minuterie.current = window.setTimeout(() => setMessage(null), erreur ? 4200 : 2400)
  }, [])

  const valeur = useMemo(
    () => ({
      signaler: (texte: string) => afficher(texte, false),
      alerter: (texte: string) => afficher(texte, true),
    }),
    [afficher],
  )

  return (
    <Contexte.Provider value={valeur}>
      {children}
      {message && (
        <div className={message.erreur ? 'toast toast-erreur' : 'toast'} role="status">
          {message.texte}
        </div>
      )}
    </Contexte.Provider>
  )
}

export function useToast(): ValeurToast {
  const valeur = useContext(Contexte)
  if (!valeur) throw new Error('useToast hors de FournisseurToast')
  return valeur
}
